import { MarketInfoProps } from '@/types/market';

interface TextSectionProps extends MarketInfoProps {
  englishMarketName?: string; // 추가
}

export const TitleSection = ({ marketName, englishMarketName }: TextSectionProps) => {
  const getMarketTitle = (englishMarketName: string | undefined) => {
    switch (englishMarketName) {
      // case 'toss':
      //   return '연동 신청이 완료됐어요!';
      default:
        return '연동이 완료되었어요!';
    }
  };

  const getMarketDescription = (englishMarketName: string | undefined) => {
    switch (englishMarketName) {
      // case 'toss':
      //   return `연동 완료까지 영업일 기준 하루 정도 소요 돼요.\n연동이 완료되면 푸시로 알려드릴게요.`;
      default:
        return `${marketName} 주문 내역을 가져오는데\n최대 30분이 소요될 수 있어요`;
    }
  };
  return (
    <section className="flex flex-col gap-[12px]">
      <h1 className="text-center text-gr-800 Title3S18">{getMarketTitle(englishMarketName)}</h1>
      <p className="whitespace-pre-wrap text-center text-gr-700 Body5M14">
        {getMarketDescription(englishMarketName)}
      </p>
    </section>
  );
};

export const DescriptionSection = ({ englishMarketName }: TextSectionProps) => {
  const getDescription = (englishMarketName: string | undefined) => {
    switch (englishMarketName) {
      // case 'toss':
      //   return '연동이 완료되면 30분 내로 최근 일주일 정보를 가져와요.\n최근 1년 정보를 가져오는데 최대 일주일이 소요될 수 있어요.';
      default:
        return '30분 내로 최근 일주일 정보를 가져와요.\n최근 1년 정보를 가져오는데 최대 일주일이 소요될 수 있어요.';
    }
  };
  return (
    <section className="flex flex-col gap-2 pt-[16px]">
      <p className="whitespace-pre-wrap text-center text-gr-700 Body5M14">
        {getDescription(englishMarketName)}
      </p>
    </section>
  );
};
